export const OFFER_ENTITY = 'offers';
export const BANK_TRANSFER = 'bank_transfer';
export const PAYMENT_METHOD_CREDIT_CARD = 'credit_card';
export const FETCH_OFFERS_FAILURE = 'FETCH_OFFERS_FAILURE';
export const FETCH_OFFERS_REQUEST = 'FETCH_OFFERS_REQUEST';
export const FETCH_OFFERS_SUCCESS = 'FETCH_OFFERS_SUCCESS';
export const FETCH_RECURRING_OFFERS_REQUEST = 'FETCH_RECURRING_OFFERS_REQUEST';
export const FETCH_RECURRING_OFFERS_SUCCESS = 'FETCH_RECURRING_OFFERS_SUCCESS';
export const FETCH_RECURRING_OFFERS_FAILURE = 'FETCH_RECURRING_OFFERS_FAILURE';
export const FETCH_OFFER_FAILURE = 'FETCH_OFFER_FAILURE';
export const FETCH_OFFER_REQUEST = 'FETCH_OFFER_REQUEST';
export const FETCH_OFFER_SUCCESS = 'FETCH_OFFER_SUCCESS';
export const RESET_SELECTED_OFFER = 'RESET_SELECTED_OFFER';
export const UPDATE_OFFER_DISCOUNT_SUCCESS = 'UPDATE_OFFER_DISCOUNT_SUCCESS';
export const LULU_EMAIL = 'flywiredocuments@in.luluforex.com';
export const QR_PAYMENT_METHOD = ['wechat_pay'];
export const MPESA_ELEMENTS_INSTRUCTIONS_PAYMENT_METHODS = ['dlocal_kes_mpesa'];
export const WECHAT_ELEMENTS_INSTRUCTIONS_PAYMENT_METHODS = ['wechat_pay'];
export const ALIPAY_PAYMENT_METHOD_PREFIX = 'alipay';
export const FORM_REDIRECT_ELEMENTS_INSTRUCTIONS_ACTION = 'form_redirect';
export const BPAY_PAYMENT_METHOD = ['bpay'];
export const BILL_PAY_PAYMENT_METHOD = [
  'online_bill_payment_cad',
  'online_bill_payment_cad_small',
  'online_bill_payment_cad_large',
];
export const EMAIL_PAYMENT_METHOD = ['interac_request_for_payment'];
export const PAYNOW_PAYMENT_OPTIONS = [
  'pt_bank_transfer_sgd',
  'pt_bank_transfer_sgd2',
  'pt_bank_transfer_sgd_high_mario',
  'pt_bank_transfer_sgd_low_mario',
  'pt_bank_transfer_sgd_mario',
  'pt_bank_transfer_sgd_domestic',
  'pt_bank_transfer_sgd_qr_only',
];
export const MUTHOOT_PAYMENT_OPTION = 'MUTHOOT_INR';
export const MUTHOOT_INR_USD_CLIENTS = 'MUTHOOT_INR_USD_CLIENTS';
export const DBIN_PAYMENT_OPTION = 'bank_transfer_db_india';
export const PT_CITY_THB_PAYMENT_OPTION = 'pt_bank_transfer_thb_citi';
export const LULU_MUTHOOTPAIR_PAYMENT_OPTION = 'LULU_INR_muthootpair';
export const AHALIA_PAYMENT_OPTION = 'Ahalia_INR';
export const LULU_INR = 'LULU_INR';
export const LULU_INR_USDCLIENTS = 'LULU_INR_USDCLIENTS';
export const LULU_PAYMENT_OPTIONS = [
  'LULU_INR',
  'LULU_INR_USDCLIENTS',
  DBIN_PAYMENT_OPTION,
  LULU_MUTHOOTPAIR_PAYMENT_OPTION,
];
export const ASTROPAY_PAYMENT_OPTIONS = [
  'astropay_br_boleto',
  'astropay_br_card_no_advance',
  'astropay_br_card',
  'astropay_br_online',
  'astropay_br_card_installment_no_advance',
  'astropay_br_card_installment',
];
export const PAYMENT_OPTIONS_WITH_OWN_IDS = [
  'KSNET',
  'db_bank_thb',
  'LULU_INR',
  'bank_transfer_db_india',
  'MUTHOOT_INR',
  'dlocal_mxn_spei',
  'LULU_INR_Large_Payments',
  'LULU_INR_USDCLIENTS',
  'pt_bank_transfer_krw2',
  LULU_MUTHOOTPAIR_PAYMENT_OPTION,
  'online_bill_payment_cad',
  'online_bill_payment_cad_small',
  'online_bill_payment_cad_large',
];
export const INDIA_PAYMENT_OPTIONS_WITH_CUSTOM_SECTION = [
  'LULU_INR',
  'LULU_INR_USDCLIENTS',
  'bank_transfer_db_india',
  'MUTHOOT_INR',
  'cashfree_inr_netbanking',
  LULU_MUTHOOTPAIR_PAYMENT_OPTION,
  AHALIA_PAYMENT_OPTION,
];
export const PAYMENT_OPTIONS_WITH_EDUCATION_LOAN_REDUCED_FEE = [
  LULU_INR,
  LULU_INR_USDCLIENTS,
  AHALIA_PAYMENT_OPTION,
];
export const MUTHOOT_PAYMENT_OPTIONS_WITH_EDUCATION_LOAN_REDUCED_FEE = [
  MUTHOOT_PAYMENT_OPTION,
  MUTHOOT_INR_USD_CLIENTS,
];
export const CHINA_CNY_FUIOU_PAYMENT_OPTIONS = [
  'fuiou_cny_tuition',
  'fuiou_cny_tuition_nodoccollection',
];

export const CHINA_LLP_PAYMENT_OPTIONS = [
  'bank_transfer_llp_btc',
  'bank_transfer_lianlianpay_edu',
  'bank_transfer_lianlianpay_edu_large_payments',
];

export const CHINA_PAYMENT_OPTIONS_WITH_CUSTOM_PAYER_ID_INFO = [
  ...CHINA_CNY_FUIOU_PAYMENT_OPTIONS,
  ...CHINA_LLP_PAYMENT_OPTIONS,
];
export const CHINA_PAYMENT_OPTIONS_WITH_CUSTOM_PAYER_RELATIONSHIP_INFO = [
  'alipay_cny',
  'wechat_cny',
];
export const CHINA_PAYMENT_OPTIONS_WITH_CUSTOM_SECTION = [
  ...CHINA_PAYMENT_OPTIONS_WITH_CUSTOM_PAYER_ID_INFO,
  ...CHINA_PAYMENT_OPTIONS_WITH_CUSTOM_PAYER_RELATIONSHIP_INFO,
];

export const CHINA_STATUS_CLARITY_PAYMENT_OPTIONS = [
  ...CHINA_CNY_FUIOU_PAYMENT_OPTIONS,
  'bank_transfer_lianlianpay_cnh_edu',
  'bank_transfer_lianlianpay_cnh_edu_large_payments',
  'bank_transfer_lianlianpay_edu',
  'bank_transfer_lianlianpay_edu_large_payments',
  'alipay_cny',
  'wechat_pay',
];

export const INTERAC_PAYMENT_OPTION_WITH_CUSTOM_SECTION =
  'interac_request_for_payment';
export const ELEMENTS_INSTRUCTIONS_PAYMENT_METHODS = [
  ...MPESA_ELEMENTS_INSTRUCTIONS_PAYMENT_METHODS,
  ...WECHAT_ELEMENTS_INSTRUCTIONS_PAYMENT_METHODS,
];
export const BANK_TRANSFER_ELEMENTS_INSTRUCTIONS_PAYMENT_METHODS = [
  'dlocal_kes_bank_transfer',
];
export enum InstructionsType {
  EMPTY = 'EMPTY',
  QR = 'QR',
  EMAIL = 'EMAIL',
  REDIRECT = 'REDIRECT',
  SCRIPT = 'SCRIPT',
  BPAY = 'BPAY',
  PAYNOW = 'PAYNOW',
  BILLPAY = 'BILLPAY',
}
export const INDIAN_PARTNER_LULU = 'Lulu Forex Pvt Ltd';
export const INDIAN_PARTNER_GSTIN_LULU = '32AABCL8839J1Z9';
export const INDIAN_PARTNER_MUTHOOT = 'Muthoot Forex';
export const INDIAN_PARTNER_GSTIN_MUTHOOT = '32AADCM3244L1ZL';
export const INDIAN_PARTNER_AHALIA = 'Ahalia Finforex Limited';
export const INDIAN_PARTNER_GSTIN_AHALIA = '32AAECA1855E1Z6';
export const INDIAN_PARTNER_LICENCE_NO_LULU = '06/2015';
export const INDIAN_PARTNER_LICENCE_NO_AHALIA = '08/2023';
export const UPOP_PAYMENT_OPTION_PATTERN = /opp.*unionpay/i;

export const OPP_UNIONPAY_CAMPAIGN = [
  'opp_unionpay_credit_boc',
  'opp_unionpay_debit_campaign',
  'opp_unionpay_debit_campaign_usd_settlement',
];
export const RECOMMENDED_OFFERS_FOR_INDIA = [
  'LULU_INR',
  'LULU_INR_USDCLIENTS',
  'MUTHOOT_INR',
  'MUTHOOT_INR_USD_CLIENTS',
  'bank_transfer_db_india',
];
export const LOAN_PROVIDER_SBI = 'SBI';
export const SBI_CAMPAIGN_OPTIONS = [
  'bank_transfer_sbi_student_loan',
  'sbi_el',
];
export const SINGAPUR_CAMPAING_OPTIONS = ['pt_bank_transfer_sgd_domestic'];

export const AED_CARD_PAYMENT_OPTIONS = ['opp_adyen_AED', 'opp_worldpay_AED'];
export const AED_CARD_WARNING_PORTALS = ['HLA', 'HBX', 'HCD'];

export const BANK_TRANSFER_FUIOU = 'bank_transfer_fuiou';
export const BANK_TRANSFER_LIANLIANPAY_EDU = 'bank_transfer_lianlianpay_edu';
export const BANK_TRANSFER_LIANLIANPAY_CNH_EDU =
  'bank_transfer_lianlianpay_cnh_edu';
export const BANK_TRANSFER_LIANLIANPAY_CNH_EDU_LARGE_PAYMENTS =
  'bank_transfer_lianlianpay_cnh_edu_large_payments';
export const WECHAT_PAY = 'wechat_pay';
export const ALIPAY = 'alipay';

export const PAYER_STUDENT_INFO_REVAMP_PAYMENT_METHODS = [
  BANK_TRANSFER_FUIOU,
  BANK_TRANSFER_LIANLIANPAY_EDU,
  BANK_TRANSFER_LIANLIANPAY_CNH_EDU,
  BANK_TRANSFER_LIANLIANPAY_CNH_EDU_LARGE_PAYMENTS,
  WECHAT_PAY,
  ALIPAY,
];
